import EgdsEdit from "./components/EgdsEdit.vue"
import EgdsView from "./components/EgdsView.vue"
import EgdsList from "./components/EgdsList.vue"

export default{
    EgdsEdit,
    EgdsView,
    EgdsList
}
